module.exports = __webpack_public_path__ + "static/media/animal-jaguar3.bdcf9822.aac";